import { BottomNavigation, BottomNavigationAction, Box } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import QrCodeScannerTwoToneIcon from "@mui/icons-material/QrCodeScannerTwoTone";
import CheckTwoToneIcon from "@mui/icons-material/CheckTwoTone";
import { useNavigate } from "react-router-dom";
import Drawer1 from "./drawer";
import React, { useState } from "react";
import { VscLayoutActivitybarLeft } from "react-icons/vsc";

import "./Dashboard.css";
import "./BottomNavigation.css"

function BottomNavigationBar() {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [showDrawer, setShowDrawer] = useState(false);
  const NavigateTo = (e) => {
    e.preventDefault();
    navigate("/single-allow-activity");
  };
  return (
   <div>
      {showDrawer && <Drawer1 showDrawer={showDrawer} setShowDrawer={setShowDrawer} />}
      <div className="bottom-navbar">
        <Box sx={{ width: "100%", position: "fixed", bottom: "0" }}>
          <BottomNavigation
            sx={{ 
            '& .MuiBottomNavigationAction-label': { fontSize: "0.8em", fontFamily: 'Ubuntu',
            }
           }}
           className="bottom-nav-action"
            showLabels
            value={value}
            onChange={(event, newValue) => {
              event.preventDefault();
              setValue(newValue);
            }}>
            <BottomNavigationAction
            className="bottom-nav-action"
              label="Activity"
              onClick={(e) => {
                // e.preventDefault();
                setShowDrawer(true);
              }}
              
              icon={<CheckTwoToneIcon />}
            />
            <BottomNavigationAction
              label="QR Scaning"
              sx={{ backgroundColor: "#14A44D", color: "white"}}
              onClick={(e) => {
                e.preventDefault();
              }}
              icon={<QrCodeScannerTwoToneIcon />}
            />
            <BottomNavigationAction
              label="Select Activity"
              sx={{ backgroundColor: "#d3a644", color: "white"}}
              onClick={NavigateTo}
              icon={<VscLayoutActivitybarLeft  />}
            />
          </BottomNavigation>
        </Box>
      </div>
    </div>
  );
}

export default BottomNavigationBar;
